<template lang="html">
  <div>
    <ul class="tabs__header">
      <li
        v-for="(tab, index) in tabNames"
        :key="tab"
        data-qa="tab-header-item"
        :class="{ tab__selected: index == selectedIndex }"
        @click="selectTab(index)"
      >
        {{ tab }}
      </li>
    </ul>
    <slot />
  </div>
</template>

<script>
import { EventBus } from '@/plugins/event-bus'

export default {
  props: {
    mode: {
      type: String,
      default: 'light',
    },
    active: {
      type: Boolean,
      default: false,
    },
    preselectedIndex: {
      type: Number,
      default: 1,
    },
    tabNames: {
      type: Array,
      required: true,
    },
  },
  emits: ['selectTab'],
  data() {
    return {
      selectedIndex: 0, // the index of the selected tab,
      i18n: window.VUE_CLI_EXPORTS.plugins.i18n,
    }
  },
  created() {
    this.selectedIndex = this.preselectedIndex //todo: make it dynamic
  },
  mounted() {
    this.selectTab(this.selectedIndex)
  },
  methods: {
    selectTab(i) {
      this.selectedIndex = i

      EventBus.$emit('select-tab', this.selectedIndex)
      this.$emit('selectTab', this.selectedIndex)
    },
  },
}
</script>

<style lang="scss" scoped>
.tabs__header {
  display: flex;
  align-content: space-between;
  list-style: none;
  margin: 0;
  padding: 0;
  overflow: hidden;
  background: #f1f4f5;
  cursor: pointer;
}
.tabs__header li {
  width: 100%;
  text-align: center;

  color: #becdd3;
  display: block;
  padding: 10px 20px;
  margin-top: 10px;
  background: #fafbfc;
  box-shadow: inset 0 -1px #a3b8c0;
  border-top: 1px solid #a3b8c0;
}
.tabs__header li.tab__selected {
  color: #41494c;
  margin-top: 0;
  font-size: 1.25rem;
  background: #fff;
  height: 100%;
  box-shadow: none;
  border-top: 1px solid #a3b8c0;
  border-left: 1px solid #a3b8c0;
  border-right: 1px solid #a3b8c0;
  border-bottom: 1px solid #a3b8c0;
}
</style>
